import drawings from 'images/index-page/index-drawings.png';
import React, { ReactElement } from 'react';
import { product } from 'copy/copy';

const FeaturesSection = (): ReactElement => (
  <div className="index-features w-100">
    <div className="index__container">
      <div className="flex column">
        <h2 className="bold index-features__header center">
          Manage end-to-end tasks from anywhere
        </h2>
        <div className="index-features__content">
          <div className="index-features__features font-size-6">
            <div className="index-features__feature pl4 mb8">
              <span className="index-features__feature-header font-size-8 bold block mb2">
                Pick up and go
              </span>
              {product.productName} gives project managers and jobsite workers a
              quick, reliable way to{' '}
              <span className="bold">
                close punch items, organize RFIs, and simplify submittals,
                onsite or off
              </span>
              .
            </div>
            <div className="index-features__feature pl4 mb8">
              <span className="index-features__feature-header font-size-8 bold block mb2">
                Keep teams on the same page
              </span>
              Organize documents and data across projects and{' '}
              <span className="bold">
                keep the office and the field in sync with a single source of
                truth
              </span>
              .
            </div>
            <div className="index-features__feature pl4">
              <span className="index-features__feature-header font-size-8 bold block mb2">
                Make better decisions
              </span>
              {product.productName} uses geolocation to visualize, connect and
              organize data, so you{' '}
              <span className="bold">
                get the info and insights you need, where you need it
              </span>
              .
            </div>
          </div>
          <div className="index-features__images column justify-center">
            <img
              className="index-features__drawings"
              src={drawings}
              alt={`${product.productName} Drawings`}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FeaturesSection;
